import { all, createStarryNight } from "@wooorm/starry-night";
import onigURL from "vscode-oniguruma/release/onig.wasm?url";
export { default as App } from "./App.svelte";
/**
 * init sets up the starryNight code syntax highlighter. This is an async operation which we usually
 * want to await before we continue with booting the app.
 */
export async function init() {
    const instance = await createStarryNight(all, {
        getOnigurumaUrlFetch() {
            const base = document.getElementsByTagName("base")[0];
            const baseHref = base ? base.href : `${window.location.origin}/`;
            return new URL(onigURL, baseHref);
        },
    });
    globalThis.STARRY_NIGHT_INSTANCE = instance;
}
